import gettext from '@sdk/lang/gettext';

import AnnouncementsEmptyStateSvg from '@web/assets/svg/Misc/empty-announcements-state.svg';

import { Wrapper } from './emptyAnnouncementsList.styles';

type Props = {
  alternative?: boolean;
};
export const EmptyAnnouncementsList = ({ alternative }: Props) => (
  <Wrapper data-testid="empty-annoucements-list">
    <AnnouncementsEmptyStateSvg aria-hidden="true" />
    {alternative
      ? gettext(
          'Looks like you have no announcements yet.\nSend an announcement to share important updates with your team.'
        )
      : gettext('No announcements yet.\nEnjoy your day and check back later.')}
  </Wrapper>
);
